// import BaseLayout from '@/components/layouts/BaseLayout'
import LayoutWithoutSidenav from '@/components/layouts/LayoutWithoutSidenav'

export default [{
  path: '/',
  component: LayoutWithoutSidenav,
  navbar: false,
  children: [ {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('@/pages/Dashboard/Dashboard')
  }]
}]
